var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content border"},[_c('div',{staticClass:"video-container"},[_c('video',{attrs:{"controls":"","autoplay":""}},[_c('source',{attrs:{"src":require("@/assets/video/How-to-Reset-My-BAU-Password.mp4"),"type":"video/mp4"}}),_vm._v(" Tarayıcınız video etiketini desteklemiyor. ")])])])
}]

export { render, staticRenderFns }